import { getCoverBanner } from "./getCoverBanner";

class WebSetting {
    public getCoverBanner = getCoverBanner;
}

export default WebSetting;